import {PersonKind} from './person-kind.enum';
import {FileReference} from './file-reference';

export class Person {
  name: string;
  surname: string;
  age = 0;
  cf: string;
  birthDay: any;
  income = 0;
  secondIncome = 0;
  incomeWeight = 0;
  theoryIncome = 0;
  kind: PersonKind;
  coverForDeadCase: number;
  coverForIp: number;
  ipProcapite: number;
  coverForDreadDisease: number;
  coverForNoSelfSuf: number;
  sex: number;
  cnl: string;
}
